import { JobSearchVisual } from './JobSearchVisual'

export default JobSearchVisual
